import { render, staticRenderFns } from "./pointOverview.vue?vue&type=template&id=5171ae82&scoped=true&"
import script from "./pointOverview.vue?vue&type=script&lang=js&"
export * from "./pointOverview.vue?vue&type=script&lang=js&"
import style0 from "./pointOverview.vue?vue&type=style&index=0&id=5171ae82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5171ae82",
  null
  
)

export default component.exports